// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__2s0_L","item":"styles_item__Cymbi"};